import React from "react";
import { withRouter } from "react-router-dom";
import CONSTANT from "./../../../constant";
import Loader from "./../../../component/common/Loader";
import AparEmployeeHeader, { normalizeManagers, mergeManagerData } from "./../../../component/common/AparEmployeeHeader";
import { getReviewingAssessment, saveReviewingAssessment, updateReviewingAssessment } from "./../../../actions/AppraisalCycleAction";

class aparReviewingManagerForm3 extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      showLoader: false,
      employeeData: null,
      kpiReportId: null,
      hasExistingAssessment: false,
      isSubmitted: false,
      agreeWithDischargeAssessment: '',
      agreeWithReporting: '',
      differenceDetails: '',
      penPictureComment: '',
      overallGrade: '',
      kpiTotal: '',
      attrTotal: '',
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = "Review by Reviewing Authority - " + CONSTANT.organisation.name;

    const locationState = this.props.location?.state || {};
    const { kpiReportId, employeeCode, employeeName, employeeNumber, effectiveFrom, effectiveTo } = locationState;
    const employeeData = { employeeCode, employeeName, employeeNumber, effectiveFrom, effectiveTo, ...normalizeManagers(locationState) };

    this.setState({ employeeData, kpiReportId });

    if (kpiReportId) {
      this.loadExistingData(kpiReportId);
    }
  }

  loadExistingData = (kpiReportId: any) => {
    this.setState({ showLoader: true });
    getReviewingAssessment({ kpiReportId }).then((res: any) => {
      const data = res?.result || res;
      if (data) {
        this.setState((prev: any) => ({
          agreeWithDischargeAssessment: data.agree_with_discharge_assessment !== undefined
            ? (data.agree_with_discharge_assessment ? 'Yes' : 'No')
            : '',
          agreeWithReporting: data.agree_with_reporting !== undefined
            ? (data.agree_with_reporting ? 'Yes' : 'No')
            : '',
          differenceDetails: data.difference_details || '',
          penPictureComment: data.pen_picture_comment || '',
          overallGrade: data.overall_grade ? String(data.overall_grade) : '',
          kpiTotal: data.kpi_total ? String(data.kpi_total) : '',
          attrTotal: data.attr_total ? String(data.attr_total) : '',
          hasExistingAssessment: !!(data.id || data.reviewing_assessment_id),
          isSubmitted: !!data.is_submitted,
          employeeData: { ...prev.employeeData, ...mergeManagerData(prev.employeeData, data) },
        }));
      }
      this.setState({ showLoader: false });
    }).catch(() => {
      this.setState({ showLoader: false });
    });
  };

  validateForm = () => {
    const { agreeWithDischargeAssessment, agreeWithReporting } = this.state;
    if (!agreeWithDischargeAssessment) {
      alert("Please select whether you agree with the assessment made by the Reporting officer with respect to discharge of responsibilities.");
      return false;
    }
    if (!agreeWithReporting) {
      alert("Please select whether you agree with the Reporting Authority's assessment.");
      return false;
    }
    return true;
  };

  callAssessmentApi = (isSubmit: boolean, callback: (res: any) => void) => {
    const { kpiReportId, hasExistingAssessment, agreeWithDischargeAssessment, agreeWithReporting, differenceDetails, penPictureComment } = this.state;

    if (!kpiReportId) {
      alert("KPI Report ID not found. Please go back and try again.");
      return;
    }

    this.setState({ showLoader: true });

    const payload = {
      kpiReportId,
      agreeWithDischargeAssessment: agreeWithDischargeAssessment === 'Yes',
      agreeWithReporting: agreeWithReporting === 'Yes',
      differenceDetails,
      penPictureComment,
      isSubmit,
    };

    const apiCall = hasExistingAssessment
      ? updateReviewingAssessment(payload)
      : saveReviewingAssessment(payload);

    apiCall.then((res: any) => {
      this.setState({ showLoader: false, hasExistingAssessment: true });
      callback(res);
    }).catch(() => {
      this.setState({ showLoader: false });
    });
  };

  handleSaveDraft = () => {
    this.callAssessmentApi(false, () => {
      alert('Saved as draft.');
    });
  };

  onSubmit = (e: any) => {
    e.preventDefault();
    if (!this.validateForm()) return;

    if (!window.confirm('Are you sure you want to submit the review? This action cannot be undone.')) return;

    this.callAssessmentApi(true, (res: any) => {
      const result = res?.result || res || {};
      this.setState({
        overallGrade: result.overallGrade ? String(result.overallGrade) : this.state.overallGrade,
        kpiTotal: result.kpiTotal ? String(result.kpiTotal) : this.state.kpiTotal,
        attrTotal: result.attrTotal ? String(result.attrTotal) : this.state.attrTotal,
        isSubmitted: true,
      });
      alert("Review submitted successfully!");
      this.props.history.push(CONSTANT.component.reviewingManagerReport.url);
    });
  };

  render() {
    const { showLoader, employeeData, agreeWithDischargeAssessment, agreeWithReporting, differenceDetails, penPictureComment, overallGrade, kpiTotal, attrTotal, isSubmitted } = this.state;

    return (
      <div className="container mx-auto px-4 py-3">
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-body">

                <div className="row mb-3">
                  <div className="col-md-8">
                    <h1 className="page-title">Review by the Reviewing Authority</h1>
                  </div>
                  <div className="col-md-4 text-right">
                    <button type="button" className="btn btn-sm cancel-button" onClick={() => this.props.history.goBack()}>
                      <i className="fa fa-arrow-left mr-2" />Back
                    </button>
                  </div>
                </div>
                <AparEmployeeHeader {...employeeData} detailViewerRole="reviewing" kpiReportId={this.state.kpiReportId} />

                {showLoader && <Loader />}

                {isSubmitted && (
                  <div className="alert alert-success mt-2">
                    <i className="fa fa-check-circle mr-1" /> This review has been submitted and is now view-only.
                  </div>
                )}

                {!showLoader && (
                  <div>
                    {/* Question 1 - Discharge of responsibilities */}
                    <div className="mb-4">
                      <label className="form-label">
                        Do you agree with the assessment made by the Reporting officer with respect to discharge of responsibilities and various attributes of the officer reported upon in Section III? (In case you agree with the assessments made by the Reporting Authority, please make a note to that effect in the space provided for you in Item No. 6 and 7 of Section III and initial it. If you do not agree with any of the numerical assessments made by the Reporting Authority, please record your assessments in the space provided for you in Item No. 6 and 7 of Section III and initial your entries).
                      </label>
                      <div className="d-flex gap-3 mt-2">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="agreeWithDischargeAssessment"
                            id="dischargeYes"
                            value="Yes"
                            checked={agreeWithDischargeAssessment === "Yes"}
                            onChange={(e) => this.setState({ agreeWithDischargeAssessment: e.target.value })}
                            disabled={isSubmitted}
                          />
                          <label className="form-check-label" htmlFor="dischargeYes">Yes</label>
                        </div>
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="agreeWithDischargeAssessment"
                            id="dischargeNo"
                            value="No"
                            checked={agreeWithDischargeAssessment === "No"}
                            onChange={(e) => this.setState({ agreeWithDischargeAssessment: e.target.value })}
                            disabled={isSubmitted}
                          />
                          <label className="form-check-label" htmlFor="dischargeNo">No</label>
                        </div>
                      </div>
                    </div>

                    {/* Question 2 - Extraordinary achievements */}
                    <div className="mb-4">
                      <label className="form-label">
                        Do you agree with the assessment of the Reporting officer in respect of extraordinary achievements and/or significant shortfalls of the officer reported upon?
                      </label>
                      <div className="d-flex gap-3 mt-2">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="agreeWithReporting"
                            id="agreeYes"
                            value="Yes"
                            checked={agreeWithReporting === "Yes"}
                            onChange={(e) => this.setState({ agreeWithReporting: e.target.value })}
                            disabled={isSubmitted}
                          />
                          <label className="form-check-label" htmlFor="agreeYes">Yes</label>
                        </div>
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="agreeWithReporting"
                            id="agreeNo"
                            value="No"
                            checked={agreeWithReporting === "No"}
                            onChange={(e) => this.setState({ agreeWithReporting: e.target.value })}
                            disabled={isSubmitted}
                          />
                          <label className="form-check-label" htmlFor="agreeNo">No</label>
                        </div>
                      </div>
                    </div>

                    {/* Question 3 */}
                    <div className="mb-4">
                      <label className="form-label">
                        In case of difference of opinion, details and reasons for the same may be given.
                      </label>
                      <textarea
                        className="form-control"
                        rows={4}
                        value={differenceDetails}
                        onChange={(e) => this.setState({ differenceDetails: e.target.value })}
                        placeholder="Enter details..."
                        disabled={isSubmitted}
                      />
                    </div>

                    {/* Question 4 */}
                    <div className="mb-4">
                      <label className="form-label">
                        Comments, if any, on the pen picture written by the Reporting Authority.
                      </label>
                      <textarea
                        className="form-control"
                        rows={4}
                        value={penPictureComment}
                        onChange={(e) => this.setState({ penPictureComment: e.target.value })}
                        placeholder="Enter comments..."
                        disabled={isSubmitted}
                      />
                    </div>

                    {/* Overall Grade (read-only, auto-computed) */}
                    <div className="mb-4">
                      <label className="form-label fw-bold">
                        Overall Grade
                      </label>
                      <p className="text-muted small mb-2">
                        <em>Overall grade (on a scale of 0-100) is auto-calculated from Item 6 (KPI grades) + Item 7 (Personal Attributes / 4).</em>
                      </p>
                      {overallGrade ? (
                        <div>
                          <div className="d-flex align-items-center gap-3 mb-2">
                            <span className="fw-bold fs-4">{parseFloat(overallGrade).toFixed(2)}</span>
                            <span className="text-muted">/ 100</span>
                          </div>
                          {(kpiTotal || attrTotal) && (
                            <div className="small text-muted">
                              {kpiTotal && <span className="me-3">KPI Total: {parseFloat(kpiTotal).toFixed(2)}</span>}
                              {attrTotal && <span>Attributes Total: {parseFloat(attrTotal).toFixed(2)}</span>}
                            </div>
                          )}
                        </div>
                      ) : (
                        <p className="text-muted fst-italic">Overall grade will be auto-computed upon submission.</p>
                      )}
                    </div>

                    {/* Submit */}
                    <div className="d-flex justify-content-end gap-2 mt-3">
                      <button type="button" className="btn btn-outline-secondary" onClick={() => this.props.history.goBack()}>
                        Back
                      </button>
                      {!isSubmitted && (
                        <button type="button" className="btn btn-secondary" onClick={this.handleSaveDraft} disabled={showLoader}>
                          {showLoader ? "Saving..." : "Save Draft"}
                        </button>
                      )}
                      {!isSubmitted && (
                        <button type="button" className="btn btn-primary" onClick={this.onSubmit} disabled={showLoader}>
                          <i className="fa fa-paper-plane mr-1" />{showLoader ? "Submitting..." : "Submit Review"}
                        </button>
                      )}
                    </div>
                  </div>
                )}

              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(aparReviewingManagerForm3);
